<span [hidden]='company.contacts.length==0' style='font-size:11px;font-weight:bold;'>&nbsp;&nbsp;&nbsp;Contacts:</span>
<ul [hidden]='company.contacts.length==0' style='list-style:none;'>
    <li *ngFor='let contact of company.contacts' style='font-size:8pt;'>
            <eic-display-contact [contact]="contact"></eic-display-contact>
    </li>
</ul>
<span [hidden]='company.offices.length < 2 && company.contacts.length==0'
    style='font-size:11px;font-weight:bold;'>&nbsp;&nbsp;&nbsp;Offices:</span>
<ul style='list-style:none;'>
    <li *ngFor='let office of company.offices' style='font-size:8pt;'>
        <eic-display-office-address [office]='office'></eic-display-office-address>
        <ul [hidden]='office.contacts.length==0'>
            <li *ngFor='let contact of office.contacts' style='font-size:8pt;'>
                <eic-display-contact [contact]='contact'></eic-display-contact>
            </li>
        </ul>
    </li>
</ul>